import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { ActivatedRoute, Router, RouterStateSnapshot } from "@angular/router";
import { AppService } from "src/app/app.service";
import { Subscription } from "rxjs/internal/Subscription";
import { faShare } from "@fortawesome/pro-solid-svg-icons";
import {
  faExclamationCircle,
  faExclamationTriangle,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { ChartsPageDataService } from "../charts-page-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { CreateNewChartsWizardComponent } from "../create-new-charts-wizard/create-new-charts-wizard.component";
import { SetDisableActions } from "src/app/store/actions/global-subheader.actions";
import { Dictionary } from "src/app/store/models/common_types";
import { ShareChartComponent } from "../share-chart/share-chart.component";
import {
  ChartMeta,
  SuggestedChartDetails,
  ChartFilters,
  LineInfo,
} from "src/app/store/models/charts-page.model";
import {
  ClearChartMeta,
  SetChartFilters,
  SetChartMeta,
  SetSuggestedChartDetails,
} from "src/app/store/actions/charts-page.actions";
import { NzMessageService } from "ng-zorro-antd/message";
import * as Highcharts from "highcharts";
import { UpdateChartsData } from "src/app/store/actions/global.actions";
import { CommonModalService } from "src/app/shared/common-modal/common-modal.service";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { forkJoin } from "rxjs";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { ChartsLIModalComponent } from "../charts-li-modal/charts-li-modal.component";
import {
  ABS_PERIOD_TYPE,
  convertPeriodMetaToUserSettings,
} from "@va/core-library/period-filter";
import {
  getSelectedPeriods,
  getOtherPeriods,
  getPeriodTypeDataId,
} from "src/app/utils/period-utils";
import { FACTSET_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import {
  VAIconRegistryService,
  arrowToBottom,
  check,
  close,
  closeCircle,
  infoCircle,
  save,
  trash,
} from "@va/core-library/icons";
@Component({
  selector: "app-charts-page",
  templateUrl: "./charts-page.component.html",
  styleUrls: ["./charts-page.component.scss"],
  host: { class: "charts-page-component" },
})
export class ChartsPageComponent implements OnInit, OnDestroy {
  createChartsSubscriber: Subscription;
  chartId = "";
  suggestedChartIndex = "";
  filterData: any = {
    allPeriods: [],
    yearType: {},
    dataView: [],
  };
  chartTypeId: number;
  chartName: string;
  downloadOptVisible = false;
  loadingDocuments = false;
  selectedTab;
  faShare = faShare;
  faExclamationCircle = faExclamationCircle;
  faExclamationTriangle = faExclamationTriangle;
  tickerModalDataReady = false;
  metaReady = false;
  addColTableData: Array<any> = [];
  selectedLiId;
  addRowTableData: Array<any> = [];
  chartsMeta: ChartMeta;
  chartsMetaRaw: any;
  rowTickers: Array<string>;
  mpt: number;
  watchlistData: Array<any> = [];
  recentlyVisitedCompanies: Array<any> = [];
  peerCompanies: Array<any> = [];
  isVisibleEditTickerModal = false;
  isVisibleEditLiModal = false;
  leftModalDataReady = false;
  stdLineItems: Array<any> = [];
  suggestedLines: Array<Dictionary<any>> = [];
  shareChartModal: NzModalRef;
  createWatchlistData: Array<any> = [];
  createNewChartsModal: NzModalRef;
  createNewModalTitle = "Create New Chart";
  createPeriod: Array<string> = [];
  selectedFilters: Dictionary<any> = {};
  selectedChart = "";
  allPeriods: Array<any> = [];
  lines: any;
  chartInstance: Highcharts.Chart;
  pageReady: boolean;
  saveCount = 0;
  hasUnsavedData = false;
  suggestedChartDetailsSubscriber: Subscription;
  chartInstanceSubscriber: Subscription;
  chartsMetaSubscriber: Subscription;
  getUSerChartIdSubscription: Subscription;
  globalAppSettingSubscriber: Subscription;
  promptModal: NzModalRef = null;
  mptList = {
    1: "Industrial & commercial",
    2: "Banking & Financial Services",
    3: "Insurance",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";
  @ViewChild(ChartsLIModalComponent)
  editChartLiModal: ChartsLIModalComponent;
  factsetCopyRightMessage = FACTSET_COPYRIGHT_MESSAGE;
  factsetDataAccess = false;
  periodsWithAvailableData;

  // modals
  isShareChartModalVisible = false;
  isDeleteAlertModalVisible = false;

  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private dataService: ChartsPageDataService,
    private modalService: NzModalService,
    private store: Store<AppState>,
    public router: Router,
    private message: NzMessageService,
    private commonModalService: CommonModalService,
    private snackBar: MatSnackBar,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      arrowToBottom,
      trash,
      save,
      check,
      close,
      closeCircle,
      infoCircle,
    ]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  ngOnInit() {
    this.createChartsSubscriber =
      this.appService.onGlobalSubheaderAction.subscribe(() => {
        this.createNewChart();
      });

    this.route.params.subscribe((paramData) => {
      this.store.dispatch(new SetDisableActions(true));
      //chartId is number   -> use id for everything
      //chartId is sugested -> use SuggestedChartDetails from store
      //chartId is null     -> fetch user chart id; if yes use it, else show splash
      if (paramData.chartId !== undefined) {
        this.chartId = paramData.chartId;

        if (this.chartId === "current") {
          let params = { ...this.route.snapshot.queryParams };
          this.appService.updateLeftPanelSource.next({
            currentChartData: {
              name: "",
              params: params,
              selected: true,
            },
          });
          params = { ...params };
          params.periods = params.periods ? [].concat(params.periods) : [];
          if (params.hideVsPeers) {
            const chartTypeId = params.chartTypeId;
            const viewBy = params.view_by || "value";
            const currentChartDetails = {
              lineId: [].concat(params.lineId),
              ticker: [].concat(params.ticker),
              periods: params.periods,
              periodType: params.period_type || ABS_PERIOD_TYPE.id,
              otherPeriods: params.other_period,
              is_annual_selected: params.is_annual_selected,
              currency: params.currency || "USD",
              source: params.source || "VA Actuals/Consensus",
              view_by: viewBy,
              revision: params.revision || "",
              chartName: params.chart_name,
              chartTypeId: parseInt(chartTypeId),
              peers: [],
              index: "0",
              scaleType:
                params.scale_type && params.scale_type.toLowerCase() === "index"
                  ? "Index"
                  : "Absolute",
            };

            this.getCurrentChartsMeta(currentChartDetails);
            this.getTickerData(false);
          } else if (params.cut === "NMV") {
            this.dataService
              .getNMVSliMapping(params.ticker, params.lineId)
              .subscribe((resp) => {
                if (resp.status !== "error") {
                  params.lineId = resp.primary_sli[0];
                  this.getPeerForCurrent(params);
                }
              });
          } else {
            this.getPeerForCurrent(params);
          }
        }

        //chartId === 'suggested will be handled by store implementation below.
        else if (this.chartId !== "suggested") {
          this.getChartsMeta(`chart_id=${this.chartId}`, null);

          //clear suggested chart details since we are opening chart with id
          this.store.dispatch(
            new SetSuggestedChartDetails({
              chartName: "",
              chartTypeId: null,
              lineId: null,
              periods: [],
              periodType: ABS_PERIOD_TYPE.id,
              otherPeriods: [],
              is_annual_selected: false,
              ticker: "",
              index: "",
              peers: [],
              scaleType: "",
            }),
          );
          this.appService.updateLeftPanelSource.next({
            dataRefresh: "true",
          });
        } else {
          if (!history.state["fromLP"]) {
            //navigated to /suggested from url
            this.router.navigate(["/charts"]);
          }
        }
        this.pageReady = true;
      } else {
        let sharedId = "";
        if (this.route.queryParams["value"]["shared_id"]) {
          sharedId = `?shared_id=${this.route.queryParams["value"]["shared_id"]}`;
        }
        this.getUSerChartIdSubscription = this.dataService
          .getUserChartId(sharedId)
          .subscribe((res) => {
            if (res.status === "success") {
              if (res.data.chart_id) {
                this.router
                  .navigate([`/charts/${res.data["chart_id"]}`])
                  .then(() => {
                    if (!sharedId) {
                      this.store.dispatch(new UpdateChartsData(null));
                    }
                  });
                if (sharedId) {
                  setTimeout(() => {
                    this.appService.updateLeftPanelSource.next({
                      dataRefresh: "true",
                    });
                  }, 100);
                }
              } else {
                //to enable create new button
                this.getTickerData(true);
                this.store.dispatch(new UpdateChartsData(null));
              }
              this.pageReady = true;
              this.appService.logUserAction(
                {},
                "",
                "",
                "CHARTS_SHARE_CREATED",
                { chart_id: res.data.chart_id },
                "",
                "CHARTS_PAGE",
              );
            } else {
              if (res.status === "error" && res.data !== "") {
                this.message.error(res.data, {
                  nzDuration: 8000,
                });
              } else this.message.error("Something went wrong");
            }
          });
      }
      if (this.allPeriods.length === 0) {
        this.getAllPeriods();
      }
    });

    this.suggestedChartDetailsSubscriber = this.store
      .select(stateGetter("chartsPage", "suggestedChartDetails"))
      .subscribe((suggestedChartDetailsT: SuggestedChartDetails) => {
        const suggestedChartDetails = this.appService.deepClone(
          suggestedChartDetailsT,
        );
        const updatedSuggestedChartDetails = {
          ...suggestedChartDetails,
          lineId: [].concat(suggestedChartDetails.lineId),
        };
        if (this.hasUnsavedData) {
          if (!this.promptModal) {
            this.promptToSave(null, updatedSuggestedChartDetails);
          } else {
            this.promptModal.afterClose.subscribe((res) => {
              if (res) {
                this.getSuggestedChartsMeta(updatedSuggestedChartDetails);
              } else {
                this.store.dispatch(new UpdateChartsData(null));
              }
            });
          }
        } else {
          if (updatedSuggestedChartDetails.chartTypeId !== null) {
            this.getSuggestedChartsMeta(updatedSuggestedChartDetails);
          }
        }
      });

    this.chartInstanceSubscriber = this.store
      .select(stateGetter("chartsPage", "chartInstance"))
      .subscribe((chartInstance: { instance: Highcharts.Chart }) => {
        // this.chartInstance = chartInstance.instance;
        this.chartInstance = this.appService.deepClone(chartInstance.instance);
      });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data && this.metaReady) {
          //raise update of common state to trigger data calls on all tabs
          this.selectedFilters = {
            ...this.selectedFilters,
          };
        }
      });

    const d = new Date();
    this.createPeriod = [`CY-${d.getFullYear()}`];
  }

  getPeerForCurrent(params: any) {
    const chartPeriods: any = [].concat(params.periods);
    const tickers = [].concat(params.ticker);
    const lineIds = [].concat(params.lineId);
    this.dataService.getCompanyPeers(tickers, lineIds).subscribe((response) => {
      if (response.status !== "error") {
        let peerTickers: Array<string> = response.peer_info.map((peer) => {
          return peer.ticker;
        });
        if (peerTickers.length > 3) {
          peerTickers = peerTickers.slice(0, 3);
        }

        const currentChartDetails: SuggestedChartDetails = {
          chartName: "", //to be created after meta resolves
          ticker: tickers,
          chartTypeId: parseInt(params.chartTypeId),
          lineId: lineIds,
          periods: chartPeriods,
          periodType: params.period_type || ABS_PERIOD_TYPE.id,
          otherPeriods: params.other_period,
          is_annual_selected: params.is_annual_selected,
          index: "0",
          peers: peerTickers,
          scaleType:
            params.scale_type && params.scale_type.toLowerCase() === "index"
              ? "Index"
              : "Absolute",
        };

        this.getCurrentChartsMeta(currentChartDetails);
        this.getTickerData(true);
      }
    });
  }

  getCurrentChartsMeta(currentChartDetails: SuggestedChartDetails) {
    //from here onwards, it is same as suggested charts flow
    this.getSuggestedChartsMeta(currentChartDetails);
  }

  createPeriodMetaUrl(periods, otherPeriods, isAnnualSelected, periodType) {
    let periodHandling = `&period_type=${periodType || ABS_PERIOD_TYPE.id}`;
    let hasPeriodData = false;

    if (periods && periods.length) {
      periodHandling += `&period=${periods.join("&period=")}`;
      hasPeriodData = true;
    }
    if (otherPeriods && otherPeriods.length) {
      periodHandling += `&other_period=${otherPeriods}`;
    }
    periodHandling += `&is_annual_selected=${
      isAnnualSelected !== undefined ? isAnnualSelected : hasPeriodData
    }`;
    return periodHandling;
  }

  getSuggestedChartsMeta(suggestedChartDetails: SuggestedChartDetails) {
    const lineIdParams = `line_ids=${suggestedChartDetails.lineId.join(
      "&line_ids=",
    )}`;
    this.suggestedChartIndex = suggestedChartDetails.index;
    let allTickers = [].concat(suggestedChartDetails.ticker);
    if (suggestedChartDetails.peers && suggestedChartDetails.peers.length) {
      allTickers = allTickers.concat(suggestedChartDetails.peers);
    }
    const tickersParams = `&ticker=${allTickers.join("&ticker=")}`;
    let periodHandling = this.createPeriodMetaUrl(
      suggestedChartDetails.periods,
      suggestedChartDetails.otherPeriods,
      suggestedChartDetails.is_annual_selected,
      suggestedChartDetails.periodType,
    );
    if (
      suggestedChartDetails.chartTypeId === 2 &&
      suggestedChartDetails.periods &&
      suggestedChartDetails.periods.length === 1
    ) {
      periodHandling += `&modify_period_range=${true}`;
    }
    const currency = suggestedChartDetails.currency || "USD";
    let chartUrl = `${lineIdParams}${tickersParams}${periodHandling}&currency=${currency}&chart_type_id=${suggestedChartDetails.chartTypeId}`;
    if (suggestedChartDetails.view_by) {
      chartUrl += `&view_by=${allTickers.join("&ticker=")}`;
    }
    this.getChartsMeta(chartUrl, suggestedChartDetails);
  }

  onChartNameChange(newName: string) {
    const data = {
      chart_id: this.chartId,
      chart_name: newName,
    };
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(data).subscribe(() => {
        this.store.dispatch(
          new UpdateChartsData({
            chartId: this.chartId,
            label: newName,
            operation: "update",
          }),
        );
      });
      this.appService.logUserAction(
        {},
        "",
        "",
        "CHARTS_EDIT_NAME",
        { chart_id: this.chartId, chart_name: newName },
        "",
        "CHARTS_PAGE",
      );
    }
  }

  onChangeSuggestedChartName(newName: string) {
    this.hasUnsavedData = false;
    this.saveToCustomChart(newName);
  }

  onExport() {
    let name = "";
    let selectedPeriods = [];
    if (this.filterData.yearType.is_annual_selected) {
      selectedPeriods = this.selectedFilters.periods;
    } else {
      selectedPeriods = this.selectedFilters.otherPeriods;
    }

    const xlsxRows = [
      [
        { type: "string", value: "Chart Name" },
        { type: "string", value: this.chartName },
      ],
      [
        { type: "string", value: "Currency" },
        { type: "string", value: this.chartsMeta.filters.currency },
      ],
      [
        { type: "string", value: "Period" },
        { type: "string", value: selectedPeriods[0] },
      ],
      [
        { type: "string", value: "Rebase to 100" },
        {
          type: "string",
          value:
            this.chartsMeta.filters.scaleType !== "Index"
              ? this.chartsMeta.filters.scaleType
              : "Index to 100",
        },
      ],
      [
        { type: "string", value: "" },
        { type: "string", value: "" },
      ],
    ];
    if (this.chartsMeta.filters.scaleType !== "Index") {
      if (
        (this.chartTypeId !== 3 &&
          this.chartsMeta.filters.dataView !== "yoy") ||
        this.chartTypeId === 3
      ) {
        xlsxRows.splice(4, 0, [
          { type: "string", value: "" },
          { type: "string", value: `All numbers in M unless stated otherwise` },
        ]);
      }
    }

    // rows = [],
    // headerRow = [];
    this.chartTypeId !== 3 &&
      xlsxRows.splice(3, 0, [
        { type: "string", value: "Values or YoY%" },
        { type: "string", value: this.chartsMeta.filters.dataView },
      ]);
    this.chartTypeId === 3 &&
      xlsxRows.splice(3, 0, [
        { type: "string", value: "Revision History" },
        {
          type: "string",
          value: this.chartsMeta.filters.revisionPeriod.startsWith("custom")
            ? this.chartsMeta.filters.revisionPeriod.split("|")[1]
            : this.chartsMeta.filters.revisionPeriod.replace("m", " months"),
        },
      ]);
    this.chartTypeId === 2 &&
      xlsxRows.splice(2, 1, [
        { type: "string", value: "Period" },
        {
          type: "string",
          value: `${selectedPeriods[0]} - ${
            selectedPeriods[selectedPeriods.length - 1]
          }`,
        },
      ]);
    switch (this.chartTypeId) {
      case 1:
        {
          const headerRow = this.rowTickers.map((item) => {
            return { type: "string", value: item };
          });
          headerRow.unshift({ type: "string", value: "" });
          xlsxRows.push(headerRow);
          const rows = this.chartInstance.options.series.map((item, index) => {
            const magnitude = `${
              this.selectedFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude &&
              this.selectedFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude !== "" &&
              this.selectedFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude !== "Abs" &&
              this.chartsMeta.filters.scaleType !== "Index" &&
              this.chartsMeta.filters.dataView !== "yoy"
                ? `(in ${
                    this.selectedFilters.lineInfo[
                      this.chartInstance.options.series[index]["custom"]
                        .parentLine
                    ].magnitude
                  })`
                : ""
            }`;
            const row = [];
            row.push({ type: "string", value: `${item.name}${magnitude}` });
            item["data"].map((d) => {
              const type = typeof d.y === "number" ? "number" : "string";
              row.push({ type: type, value: d.y });
              return d;
            });
            return row;
          });
          rows.map((row) => {
            xlsxRows.push(row);
            return row;
          });
        }

        //common
        //  const tableCap = [
        //   [{ type: "string", value: this.chartName }],
        //   [{ type: "string", value: this.chartsMeta.filters.periods }],
        // ];
        // xlsxRows = tableCap.concat(xlsxRows);

        break;
      case 2:
        {
          let tsRow = [];
          const headRow = [{ type: "string", value: "Ticker" }];
          this.chartInstance.xAxis[0].categories.map((x) =>
            headRow.push({ type: "string", value: x }),
          );
          this.chartInstance.options.series.map((item) => {
            if (item.name !== "") {
              tsRow = [];
              if (item["custom"].isLineItem) {
                const magnitude = `${
                  this.selectedFilters.lineInfo[item["custom"].lineId]
                    .magnitude &&
                  this.selectedFilters.lineInfo[item["custom"].lineId]
                    .magnitude !== "" &&
                  this.selectedFilters.lineInfo[item["custom"].lineId]
                    .magnitude !== "Abs" &&
                  this.chartsMeta.filters.scaleType !== "Index" &&
                  this.chartsMeta.filters.dataView !== "yoy"
                    ? `(in ${
                        this.selectedFilters.lineInfo[item["custom"].lineId]
                          .magnitude
                      })`
                    : ""
                }`;
                xlsxRows.push([]);
                xlsxRows.push([
                  { type: "string", value: `${item.name}${magnitude}` },
                ]);
                xlsxRows.push(headRow);
              } else {
                tsRow.push({ type: "string", value: item.name });
                item["data"].map((val) => {
                  tsRow.push({ type: "string", value: val.y });
                  return val.y;
                });
                xlsxRows.push(tsRow);
              }
            }
            return item;
          });
        }

        break;
      case 3:
        {
          let row = [];
          this.rowTickers.map((ticker, index) => {
            const rows = [];
            rows.push(
              { type: "string", value: ticker },
              { type: "string", value: "Period" },
            );
            xlsxRows.push([]);
            xlsxRows.push(rows);
            this.chartInstance.options.series.map((item) => {
              if (item.name !== "") {
                // row = [];
                if (item["custom"].isLineItem) {
                  row = [];
                  // rowData = [];
                  const magnitude = `${
                    this.selectedFilters.lineInfo[item["custom"].lineId]
                      .magnitude &&
                    this.selectedFilters.lineInfo[item["custom"].lineId]
                      .magnitude !== "" &&
                    this.selectedFilters.lineInfo[item["custom"].lineId]
                      .magnitude !== "Abs" &&
                    this.chartsMeta.filters.scaleType !== "Index"
                      ? `(in ${
                          this.selectedFilters.lineInfo[item["custom"].lineId]
                            .magnitude
                        })`
                      : ""
                  }`;
                  row.push({
                    type: "string",
                    value: `${item.name}${magnitude}`,
                  });
                } else {
                  if (item.name.split("-")[0] === this.rowTickers[index]) {
                    row.length ? row.splice(1) : null;
                    row.push({
                      type: "string",
                      value: item.name.split("-").slice(1).join("-"),
                    });
                    const dateRow = [
                      { type: "string", value: "" },
                      { type: "string", value: "" },
                    ];
                    item["data"].length &&
                      item["data"].map((d) => {
                        const xDate = Highcharts.dateFormat("%d-%b-%Y", d.x);
                        dateRow.push({ type: "string", value: xDate });
                        const type =
                          typeof d.y === "number" ? "number" : "string";
                        row.push({ type: type, value: d.y });
                        return d;
                      });
                    xlsxRows.push(dateRow);
                    xlsxRows.push([...row]);
                  }
                }
                // if(rowData.length){
                // rowData.map(d => row.push(d));
                // dataRows.push(rowData);
                // }
              }
              return item;
            });
            return ticker;
          });
        }

        break;
      default:
        console.error(
          `Chart with type id ${this.chartTypeId} is not supported`,
        );
    }

    // xlsxRows = [[{type: "string", value: "#"}, {type: "string", value:"LI1"}, {type: "string", value:"LI2"}],
    //   [{type: "string", value: "AAL"}, {type: "number", value:100}, {type: "string", value:""}],
    // [{type: "string", value: "DAL"}, {type: "number", value:100}, {type: "string", value:""}],
    // [{type: "string", value: "UAL"}, {type: "number", value:100}, {type: "string", value:""}]];

    // xlsxRows = Highcharts.map(rows.slice(1), function(row) {
    //   return Highcharts.map(row, function(column) {
    //     return {
    //       type: typeof column === "number" ? "number" : "string",
    //       value: column
    //     };
    //   });
    // });
    name = this.chartName || "chart";

    window.zipcelx({
      filename: name,
      sheet: {
        data: xlsxRows,
      },
    });
    this.appService.logUserAction(
      {},
      "",
      "",
      "CHARTS_DOWNLOAD",
      {
        lines: this.lines,
        tickers: this.rowTickers,
        chart_id: this.chartId,
        chart_type_id: this.chartTypeId,
        downloadInfo: "Export_Value",
      },
      "",
      "CHARTS_PAGE",
    );
  }

  createNewChart() {
    this.saveCount = 0;
    const filterData = {
      allPeriods: this.allPeriods,
      yearType: {},
    };
    this.createNewChartsModal = this.modalService.create({
      nzTitle: this.createNewModalTitle,
      nzContent: CreateNewChartsWizardComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: [],
        userChartId: this.chartId,
        watchlists: this.createWatchlistData,
        recentlyVisitedCompanies: this.recentlyVisitedCompanies,
        //stdLineItems: this.stdLineItems,
        addColTableData: [],
        currentIndex: 0,
        title: this.createNewModalTitle,
        createPeriod: this.createPeriod,
        filterData: filterData,
      },
      nzWrapClassName:
        "charts-modal-container stepper-wizard-container vertical-center-modal",
      nzFooter: [
        {
          label: "Restart",
          type: "default",
          onClick: (data) => {
            data.addRowTableData = [];
            data.addColTableData = [];
            this.createNewModalTitle = "Create New Chart";
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 1;
          },
        },
        {
          label: "Back to Company Selection",
          type: "default",
          onClick: (data) => {
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 2;
          },
        },
        {
          label: "Back to Line Item Selection",
          type: "default",
          onClick: (data) => {
            data.moveToPreviousStep();
          },
          show: (data) => {
            return data.currentIndex === 3;
          },
        },
        {
          label: "Next",
          type: "primary",
          loading: (data) => data.createLiDataFetch,
          onClick: (data) => {
            data.createLiDataFetch = true;
            data.tickers = data.addRowTableData.map((data) => {
              return data.ticker;
            });
            const reqObj = {
              currency: "USD",
              tickers: data.tickers,
              show_suggested_lines: true,
            };
            this.dataService.getStdLineItems(reqObj).subscribe((res) => {
              data.stdLineItems = [...res.data];
              const _suggestedLines: Array<any> = res.data.filter(
                (d) => d.tab_full_name === "Suggested Line Items",
              );
              this.suggestedLines = _suggestedLines.length
                ? _suggestedLines[0].tab_sli_data.map((l) => {
                    return {
                      disabled: false,
                      label: l.name,
                      isLeaf: true,
                      level: 2,
                      header: false,
                      sliid: l.sli_id,
                      line_count: l.line_count,
                      id: l.uniquesliid,
                    };
                  })
                : [];
              if (this.suggestedLines.length > 0) {
                this.suggestedLines = [
                  {
                    suggestion_header: "Suggestions: ",
                    isLeaf: true,
                    disabled: true,
                  } as any,
                ].concat(this.suggestedLines);
              } else {
                this.suggestedLines = [
                  {
                    suggestion_header: "No suggestion found ",
                    isLeaf: true,
                    disabled: true,
                  } as any,
                ].concat(this.suggestedLines);
              }
              data.createLiDataFetch = false;
              setTimeout(() => data.moveToNextStep(), 200);
            });
          },
          show: (data) => {
            return data.currentIndex === 1;
          },
          disabled: (data) => {
            return (
              data.addRowTableData.length < 1 ||
              data.addRowTableData.length > 10
            );
          },
        },
        {
          label: "Next",
          type: "primary",
          onClick: (data) => {
            data.moveToNextStep();
          },
          show: (data) => {
            return data.currentIndex === 2;
          },
          disabled: (data) => {
            return (
              data.addColTableData.length < 1 || data.addColTableData.length > 2
            );
          },
        },
        {
          label: "Save",
          type: "primary",
          onClick: (data) => {
            this.saveCount++;
            if (this.saveCount <= 1) {
              this.saveNewChart(data);
            }
          },
          show: (data) => {
            return data.currentIndex === 3;
          },
          disabled: (data) => {
            return (
              data.chartName === "" ||
              (data.context === "line" &&
                (data.createPeriod.length === 0 || data.revision.length === 0))
            );
          },
        },
      ],
    });
  }

  convertYearTypeToPeriod(yearType: any) {
    let period = "";

    if (yearType["type"] === "Calendarized") {
      period = "CY";
    } else {
      period = "FY";
    }
    if (yearType["period"] === "1st Half") {
      period = `1H${period}`;
    } else if (yearType["period"] === "2nd Half") {
      period = `2H${period}`;
    } else if (yearType["period"] === "Q1") {
      period = `1Q${period}`;
    } else if (yearType["period"] === "Q2") {
      period = `2Q${period}`;
    } else if (yearType["period"] === "Q3") {
      period = `3Q${period}`;
    } else if (yearType["period"] === "Q4") {
      period = `4Q${period}`;
    }
    period += `-${yearType.year}`;
    return period;
  }

  getChartsMeta(url: string, suggestedChartDetails: SuggestedChartDetails) {
    if (this.metaReady === false && this.chartsMetaSubscriber) {
      this.chartsMetaSubscriber.unsubscribe();
    }
    this.selectedFilters = {};
    this.metaReady = false;
    this.store.dispatch(new ClearChartMeta());

    this.chartsMetaSubscriber = this.dataService
      .getChartsMeta(url)
      .subscribe((response: any) => {
        if (this.metaReady === false) {
          if (response.status === "error") {
            const sharedId = "";
            this.dataService.getUserChartId(sharedId).subscribe((res) => {
              if (res.data.chart_id) {
                this.router
                  .navigate([`/charts/${res.data["chart_id"]}`])
                  .then(() => {
                    this.appService.updateLeftPanelSource.next(null);
                  });
              } else {
                this.router.navigate([`/charts`]);
              }
            });
            return;
          }
          this.factsetDataAccess = response.factset_data_access;
          if (!this.factsetDataAccess) {
            this.snackbarMessage =
              "You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.";
            this.snackBarRef = this.snackBar.openFromTemplate(
              this.infoTemplate,
              {
                panelClass: "info",
                duration: 5000,
                verticalPosition: "top",
              },
            );
          }
          if (this.chartId === "current") {
            if (suggestedChartDetails.chartName) {
              this.appService.updateLeftPanelSource.next({
                currentChartData: {
                  name: suggestedChartDetails.chartName,
                },
              });
            } else if (suggestedChartDetails.chartTypeId === 3) {
              this.appService.updateLeftPanelSource.next({
                currentChartData: {
                  name: `${suggestedChartDetails.ticker} vs Peers ${response.line_info[0].name} - Revision`,
                },
              });
            } else {
              this.appService.updateLeftPanelSource.next({
                currentChartData: {
                  name: `${suggestedChartDetails.ticker} vs Peers ${response.line_info[0].name}`,
                },
              });
            }
          }
          const chartTypeId =
            suggestedChartDetails !== null
              ? suggestedChartDetails.chartTypeId
              : response.chart_type_id;
          this.chartsMetaRaw = response;
          // if (
          //   suggestedChartDetails &&
          //   suggestedChartDetails.chartTypeId === 2 &&
          //   suggestedChartDetails.periods["from"] ===
          //     suggestedChartDetails.periods["to"]
          // ) {
          //   suggestedChartDetails.periods = {
          //     from: this.convertYearTypeToPeriod(response.year_type["from"]),
          //     to: this.convertYearTypeToPeriod(response.year_type["to"])
          //   };
          // }
          this.chartsMeta = {
            chartName:
              suggestedChartDetails !== null
                ? this.chartId === "current" && !suggestedChartDetails.chartName
                  ? `${suggestedChartDetails.ticker} vs Peers ${
                      response.line_info[0].name
                    } ${
                      suggestedChartDetails.chartTypeId === 3
                        ? " - Revision"
                        : ""
                    }`
                  : suggestedChartDetails.chartName
                : response.chart_name,
            chartTypeId: chartTypeId,
            filters: {
              currency:
                suggestedChartDetails !== null
                  ? response.chart_currency
                  : response.chart_meta.currency,
              dataView:
                suggestedChartDetails !== null
                  ? suggestedChartDetails.view_by || "value"
                  : response.chart_meta.viewBy || null,
              lines: response.line_info.map((lInfo) => {
                return {
                  name: lInfo.name,
                  uniqueSliId: lInfo.uniquesliid,
                  unit: lInfo.unit,
                  magnitude: lInfo.magnitude,
                  currSymbol: lInfo.curr_symbol,
                  isValuationRatio: lInfo.is_valuation_ratio,
                };
              }),
              periods: getSelectedPeriods(response.year_type, false),
              otherPeriods: getOtherPeriods(response.year_type),
              periodType: getPeriodTypeDataId(response.year_type),
              yearType: response.year_type,
              // tsYearType:
              //   chartTypeId === 2
              //     ? suggestedChartDetails !== null && !response.year_type
              //       ? {
              //           from: {
              //             type: "Calendarized",
              //             year: suggestedChartDetails.periods["from"].split(
              //               "-"
              //             )[1],
              //             period: "Full Year"
              //           },
              //           to: {
              //             type: "Calendarized",
              //             year: suggestedChartDetails.periods["to"].split(
              //               "-"
              //             )[1],
              //             period: "Full Year"
              //           }
              //         }
              //       : response.year_type || null
              //     : null,
              revisionPeriod:
                suggestedChartDetails !== null
                  ? suggestedChartDetails.revision || "12m"
                  : response.chart_meta.revision || null,
              scaleType:
                suggestedChartDetails !== null
                  ? suggestedChartDetails.scaleType || "Absolute"
                  : response.chart_meta.scale_type || null,
              tickers: (response.ticker_info || []).map((tInfo) => {
                return {
                  name: tInfo.name,
                  ticker: tInfo.ticker,
                };
              }),
            },
          };
          this.getTickerData(true);
          this.setSubheaderTitle();
          this.store.dispatch(
            new SetChartMeta(this.appService.deepClone(this.chartsMeta)),
          );
          this.populateFiltersFromMeta();
          this.metaReady = true;
        }
      });
  }

  setSubheaderTitle() {
    const chartTypeNames =
      this.chartId === "current"
        ? "Create Chart"
        : this.chartId === "suggested"
          ? "Suggested Charts"
          : "Custom Charts";
    this.store.dispatch(
      new GlobalSubheaderActions.SubheaderTitleChanged({
        title: chartTypeNames,
        sup: "",
        link: "",
      }),
    );
  }

  getAllPeriods() {
    this.dataService.getPeriods().subscribe((res) => {
      if (res["status"] === "success") {
        this.allPeriods = res["period"];
        this.filterData.allPeriods = res["period"];
      }
    });
  }
  populateFiltersFromMeta() {
    this.rowTickers = this.chartsMeta.filters.tickers.map((data) => {
      return data.ticker;
    });
    this.addRowTableData = this.chartsMetaRaw.ticker_info;
    this.addColTableData = this.chartsMetaRaw.line_info;
    this.selectedLiId = this.chartsMetaRaw.line_info.map(
      (item) => item.uniquesliid,
    );
    this.mpt = this.chartsMetaRaw.mpt;
    this.chartTypeId = this.chartsMeta.chartTypeId;
    this.filterData = {
      ...this.filterData,
      yearType: this.chartsMeta.filters.yearType,
    };

    switch (this.chartTypeId) {
      case 1:
        this.selectedChart = "charts-page-bar";
        // this.filterData.yearType = this.chartsMeta.filters.yearType;
        break;
      case 2:
        this.selectedChart = "charts-page-timeseries";
        // this.filterData.yearType = this.chartsMeta.filters.tsYearType;
        break;
      case 3:
        this.selectedChart = "charts-page-revision";
        break;
      default:
        console.error(
          `Chart with type id ${this.chartTypeId} is not supported`,
        );
    }
    const lineInfoDict = {};
    this.lines = this.chartsMeta.filters.lines.map((data) => {
      lineInfoDict[data.uniqueSliId] = data;
      return data.uniqueSliId;
    });
    this.selectedFilters = {
      chartId: this.chartId,
      currency: this.chartsMeta.filters.currency,
      revisionPeriod: this.chartsMeta.filters.revisionPeriod,
      tickers: this.rowTickers,
      selectedTickersInfo: this.chartsMeta.filters.tickers,
      lines: this.lines,
      lineInfo: lineInfoDict,
      scaleType: this.chartsMeta.filters.scaleType === "Absolute" ? 1 : 2,
      periods: this.chartsMeta.filters.periods,
      otherPeriods: this.chartsMeta.filters.otherPeriods,
      periodType: this.chartsMeta.filters.periodType,
    };
    if (this.chartsMeta.filters.dataView) {
      this.selectedFilters["dataView"] = this.chartsMeta.filters.dataView;
    }
    if (this.selectedChart === "charts-page-revision") {
      this.selectedFilters["revisionPeriod"] =
        this.chartsMeta.filters.revisionPeriod;
    }

    this.chartName = this.chartsMeta.chartName;

    const postObj = {
      tickers: this.rowTickers,
      show_suggested_lines: true,
    };
    this.dataService.getStdLineItems(postObj).subscribe((res) => {
      this.leftModalDataReady = true;
      this.stdLineItems = [...res.data];
      const _suggestedLines: Array<any> = res.data.filter(
        (d) => d.tab_full_name === "Suggested Line Items",
      );
      this.suggestedLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];
      if (this.suggestedLines.length > 0) {
        this.suggestedLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ].concat(this.suggestedLines);
      } else {
        this.suggestedLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ].concat(this.suggestedLines);
      }
    });

    this.getPeriodsWithAvailableData(this.rowTickers);
  }

  saveNewChart(data) {
    let metaData = {};
    const periodSettings = convertPeriodMetaToUserSettings(data.yearTypeData);
    switch (data.context) {
      case "line":
        this.chartTypeId = 3;
        metaData = {
          currency: "USD",
          revision: data.revision,
          scale_type: "Absolute",
          period: periodSettings,
        };
        break;
      case "Comparison":
        this.chartTypeId = 1;
        metaData = {
          currency: "USD",
          period: periodSettings,
          scale_type: "Absolute",
          viewBy: "value",
        };
        break;
      case "Timeseries":
        this.chartTypeId = 2;
        metaData = {
          currency: "USD",
          period: periodSettings,
          scale_type: "Absolute",
          viewBy: "value",
        };
        break;
      default:
        this.chartTypeId = 3; //what will be the id here?
    }
    const tickers = data.addRowTableData.map((el) => el.ticker);
    const lineids = data.addColTableData.map((el) => el.uniquesliid);
    const reqObj = {
      chart_name: data.chartName,
      chart_type_id: this.chartTypeId,
      line_ids: lineids,
      tickers: tickers,
      chart_meta_data: metaData,
    };
    this.dataService.saveNewChart(reqObj).subscribe((res) => {
      if (res["status"] === "success") {
        this.chartId = res.chart_id;
        this.router.navigate([`/charts/${this.chartId}`]);
        this.appService.updateLeftPanelSource.next({
          dataRefresh: "true",
        });
        // .then(() => {

        //   this.store.dispatch(
        //     new UpdateChartsData({
        //       chartId: this.chartId,
        //       label: reqObj["chart_name"],
        //       operation: "add",
        //       chartTypeId: reqObj["chart_type_id"]
        //     })
        //   );
        // });
      }
      this.createNewChartsModal.destroy();
      //need to make update LP and chart data calls
    }),
      (err) => {
        console.error(err);
        this.saveCount = 0;
      };
  }

  getTickerData(fetchPeers = true) {
    this.tickerModalDataReady = false;
    this.dataService.getWatchlists().subscribe((resp) => {
      this.watchlistData = JSON.parse(JSON.stringify(resp.data));
      this.createWatchlistData = JSON.parse(JSON.stringify(resp.data));
      const apiCalls = [this.dataService.getRecentlyVisitedCompanies()];
      if (this.chartsMeta && fetchPeers) {
        apiCalls.push(
          this.dataService.getCompanyPeers(
            this.chartsMeta.filters.tickers.map((t) => t.ticker),
            null,
          ),
        );
      }
      forkJoin(apiCalls).subscribe((res) => {
        this.tickerModalDataReady = true;
        this.store.dispatch(new SetDisableActions(false));
        if (res[0].status === "success") {
          this.recentlyVisitedCompanies = this.appService.cloneArray(
            res[0].data,
          );
        }
        const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
          const company = {
            name: el.name,
            ticker: el.ticker,
            sli_comps_id: 0,
            mpt: el.mpt,
            isSelected: false,
          };
          return company;
        });
        if (res[1] && res[1].status === "success") {
          this.peerCompanies = this.appService
            .cloneArray(res[1].peer_info)
            .map((item) => ({ ...item, full_name: item.name }));
        }
        const peerComps = this.peerCompanies.map((pc) => {
          const company = {
            name: pc.name,
            ticker: pc.ticker,
            sli_comps_id: 0,
            mpt: pc.mpt,
            isSelected: false,
          };
          return company;
        });

        const recentViewCompany = {
          watchername: "Recently viewed (up to 30)",
          company_info: recentViewCompanies,
        };

        this.watchlistData.unshift(recentViewCompany);
        this.createWatchlistData.unshift(recentViewCompany);

        const peerData = {
          watchername: "Suggested Peers",
          company_info: peerComps,
        };

        this.watchlistData.unshift(peerData);

        for (let i = 0; i < this.watchlistData.length; i++) {
          const parsedWatchlistData = this.watchlistData[i].company_info.map(
            (el) => {
              let company = {};

              company = {
                name: el.name,
                sli_comps_id: el.sli_comps_id || 0,
                ticker: el.ticker,
                mpt: el.mpt,
                isSelected: false,
              };
              el = company;
              return el;
            },
          );
          this.watchlistData[i].company_info = JSON.parse(
            JSON.stringify(parsedWatchlistData),
          );
        }

        for (let i = 1; i < this.createWatchlistData.length; i++) {
          const parsedData = this.createWatchlistData[i].company_info.map(
            (el) => {
              let company = {};
              company = {
                name: el.name,
                sli_comps_id: el.sli_comps_id || 0,
                ticker: el.ticker,
                mpt: el.mpt,
                isSelected: false,
              };
              el = company;
              return el;
            },
          );
          this.createWatchlistData[i].company_info = JSON.parse(
            JSON.stringify(parsedData),
          );
        }
      });
    });
  }

  shareChart() {
    if (this.chartId !== "suggested" && this.chartId !== "current") {
      this.isShareChartModalVisible = true;
      this.shareChartModal = this.modalService.create({
        nzTitle: "Share Chart",
        nzContent: ShareChartComponent,
        nzMaskClosable: false,
        nzComponentParams: {
          chartId: this.chartId,
        },
        nzWrapClassName: "charts-modal-container vertical-center-modal",
        nzFooter: null,
        nzOnCancel: (): void => {
          this.isShareChartModalVisible = false;
        },
      });
    }
  }

  showDeleteAlertModal = (): void => {
    if (this.chartId !== "suggested" && this.chartId !== "current") {
      const title = `Delete this chart?`;

      const message = `You cannot recover this chart once deleted. Hit 'Delete' to proceed.`;

      let modal: NzModalRef = null;

      const primaryAction = () => {
        modal.close();
        this.deleteChart();
        this.isDeleteAlertModalVisible = false;
      };

      this.isDeleteAlertModalVisible = true;

      //configure modal to show alert message
      const modalOptions = {
        title: title,
        body: message,
        accentColor: "#ff4e33",
        icon: faExclamationCircle as IconDefinition,
        actionPrimaryText: "Delete",
        actionSecondaryText: "Cancel",
        onPrimaryClick: primaryAction,
        onSecondaryClick: () => {
          modal.close();
          this.isDeleteAlertModalVisible = false;
        },
        onCancel: (): void => {
          this.isDeleteAlertModalVisible = false;
        },
      };

      modal = this.commonModalService.create(modalOptions);
    }
  };

  deleteChart() {
    //Need to stop propogation since clicking the close also triggers the tab click
    //event.stopPropagation();
    //this.showDeleteModal = true;
    //this.tabIndexToDelete = tabId;
    //this.showDeleteAlertModal();
    this.dataService.deleteChart(this.chartId).subscribe((res) => {
      if (res["status"] === "success") {
        this.appService.logUserAction(
          {},
          "",
          "",
          "CHARTS_DELETE",
          { chart_id: this.chartId },
          "",
          "CHARTS_PAGE",
        );
      }
      const sharedId = "";
      this.dataService.getUserChartId(sharedId).subscribe((res) => {
        const deletedChartId = this.chartId;
        if (res.data.chart_id) {
          this.router.navigate([`/charts/${res.data["chart_id"]}`]).then(() => {
            this.store.dispatch(
              new UpdateChartsData({
                chartId: deletedChartId,
                operation: "delete",
              }),
            );
          });
        } else {
          this.router.navigate([`/charts`]).then(() => {
            this.store.dispatch(
              new UpdateChartsData({
                chartId: deletedChartId,
                operation: "delete",
              }),
            );
          });
        }
      });
    });
  }

  updateCurrency(currency) {
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: currency,
        scale_type: this.chartsMeta.filters.scaleType,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
      },
    };
    if (this.chartTypeId === 3) {
      postData["chart_meta_data"]["revision"] =
        this.chartsMeta.filters.revisionPeriod;
    } else {
      postData["chart_meta_data"]["viewBy"] = this.chartsMeta.filters.dataView;
    }
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
      this.chartsMeta.filters.currency = currency;
      this.getLineInfoAndUpdateStore(this.lines, null);
    } else {
      this.dataService.updateCharts(postData).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.chartsMeta.filters.currency = currency;
            this.getLineInfoAndUpdateStore(this.lines, null);
            this.appService.logUserAction(
              {},
              "",
              "",
              "CHARTS_UPDATE_CURRENCY",
              { user_currency: currency, chart_id: this.chartId },
              "",
              "CHARTS_PAGE",
            );
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }

  updateRevisionPeriod(param) {
    console.error(`Not implemented${param}`)!;
  }

  updateEstimates(newEstimates) {
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: this.chartsMeta.filters.currency,
        revision: this.chartsMeta.filters.revisionPeriod,
        scale_type: this.chartsMeta.filters.scaleType,
        period: newEstimates,
      },
    };
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(postData).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.appService.logUserAction(
              {},
              "",
              "",
              "CHARTS_UPDATE_ESTIMATE",
              { period: newEstimates, chart_id: this.chartId },
              "",
              "CHARTS_PAGE",
            );
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
    this.chartsMeta.filters.periods = newEstimates;
    this.store.dispatch(
      new SetChartFilters(this.appService.deepClone(this.chartsMeta.filters)),
    );
    this.selectedFilters = {
      ...this.selectedFilters,
      periods: newEstimates,
    };
  }

  updateScaleType(newScaleType) {
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: this.chartsMeta.filters.currency,
        scale_type: newScaleType,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
      },
    };
    if (this.chartTypeId === 1 || this.chartTypeId === 2) {
      postData["chart_meta_data"]["viewBy"] = this.chartsMeta.filters.dataView;
    }
    if (this.chartTypeId === 3) {
      postData["chart_meta_data"]["revision"] =
        this.chartsMeta.filters.revisionPeriod;
    }
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(postData).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.appService.logUserAction(
              {},
              "",
              "",
              "CHARTS_UPDATE_SCALE_TYPE",
              { scale_type: newScaleType, chart_id: this.chartId },
              "",
              "CHARTS_PAGE",
            );
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
    this.chartsMeta.filters.scaleType = newScaleType;
    this.store.dispatch(
      new SetChartFilters(this.appService.deepClone(this.chartsMeta.filters)),
    );
    this.selectedFilters = {
      ...this.selectedFilters,
      scaleType: newScaleType === "Absolute" ? 1 : 2,
    };
  }

  updateDataView(newDataView) {
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: this.chartsMeta.filters.currency,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
        scale_type: this.chartsMeta.filters.scaleType,
        viewBy: newDataView,
      },
    };
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(postData).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.appService.logUserAction(
              {},
              "",
              "",
              "CHARTS_UPDATE_DATA_VIEW",
              { viewBy: newDataView, chart_id: this.chartId },
              "",
              "CHARTS_PAGE",
            );
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
    this.chartsMeta.filters.dataView = newDataView;
    this.store.dispatch(
      new SetChartFilters(this.appService.deepClone(this.chartsMeta.filters)),
    );
    this.selectedFilters = {
      ...this.selectedFilters,
      dataView: newDataView,
    };
  }

  updateRevision(newRevision) {
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: this.chartsMeta.filters.currency,
        revision: newRevision,
        scale_type: this.chartsMeta.filters.scaleType,
        period: convertPeriodMetaToUserSettings(this.filterData.yearType),
      },
    };

    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(postData).subscribe(() => {
        this.appService.logUserAction(
          {},
          "",
          "",
          "CHARTS_UPDATE_REVISION",
          { revision: newRevision, chart_id: this.chartId },
          "",
          "CHARTS_PAGE",
        );
      });
    }
    this.chartsMeta.filters.revisionPeriod = newRevision;
    this.store.dispatch(
      new SetChartFilters(this.appService.deepClone(this.chartsMeta.filters)),
    );
    this.selectedFilters = {
      ...this.selectedFilters,
      revisionPeriod: newRevision,
    };
  }

  updateYearType(param) {
    const { updatedPeriodData, periodUserSettingData } = param;
    this.chartsMeta.filters.yearType = updatedPeriodData;
    this.filterData = {
      ...this.filterData,
      yearType: updatedPeriodData,
    };
    const selectedPeriodList = getSelectedPeriods(
      param.updatedPeriodData,
      false,
    );
    const otherPeriodList = getOtherPeriods(param.updatedPeriodData);
    const periodType = getPeriodTypeDataId(updatedPeriodData);
    this.selectedFilters = {
      ...this.selectedFilters,
      periods: selectedPeriodList,
      otherPeriods: otherPeriodList,
      periodType: periodType,
      yearType: updatedPeriodData,
    };
    this.store.dispatch(
      new SetChartFilters(this.appService.deepClone(this.chartsMeta.filters)),
    );
    // let selectedPeriod: any = [param.selectedYear];
    // let period = {};
    // if (this.chartTypeId === 2) {
    //   period = { from: param.start, to: param.end };
    //   selectedPeriod = period;
    //   // this.chartsMeta.filters.tsYearType = {
    //   //   from: param.from,
    //   //   to: param.to
    //   // };
    //   this.chartsMeta.filters.periods = selectedPeriod;
    //   this.store.dispatch(new SetChartFilters(this.chartsMeta.filters));
    // } else {
    //   this.chartsMeta.filters.yearType = {
    //     type: param.type,
    //     year: param.year,
    //     period: param.periodVal
    //   };
    //   this.chartsMeta.filters.periods = selectedPeriod;
    //   this.store.dispatch(new SetChartFilters(this.chartsMeta.filters));
    // }
    const postData = {
      chart_id: this.chartId,
      chart_meta_data: {
        currency: this.chartsMeta.filters.currency,
        period: periodUserSettingData,
        scale_type: this.chartsMeta.filters.scaleType,
        revision: this.chartsMeta.filters.revisionPeriod || undefined,
        viewBy:
          this.chartTypeId !== 3 ? this.chartsMeta.filters.dataView : undefined,
      },
    };

    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(postData).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.appService.logUserAction(
              {},
              "",
              "",
              "CHARTS_UPDATE_PERIOD",
              { period: periodUserSettingData, chart_id: this.chartId },
              "",
              "CHARTS_PAGE",
            );
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }

  downloadValue(downloadType: number) {
    this.downloadOptVisible = false;
    let downloadTypeName = "";
    switch (downloadType) {
      case 0:
        downloadTypeName = "Download_PNG";
        break;
      case 1:
        downloadTypeName = "Download_JPEG";
        break;
      case 2:
        downloadTypeName = "Download_PDF";
        break;
      case 3:
        downloadTypeName = "Download_SVG";
        break;
      case 4:
        downloadTypeName = "Print_Chart";
        break;
      default:
        downloadTypeName = "Download_PNG";
    }
    this.appService.logUserAction(
      {},
      "",
      "",
      "CHARTS_DOWNLOAD",
      {
        lines: this.lines,
        tickers: this.rowTickers,
        chart_id: this.chartId,
        chart_type_id: this.chartTypeId,
        downloadInfo: downloadTypeName,
      },
      "",
      "CHARTS_PAGE",
    );
    this.chartInstance.options.title.text = this.chartName;
    switch (downloadType) {
      case 0:
        this.chartInstance.exportChart(
          {
            type: "image/png",
            filename: this.chartName,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 1:
        this.chartInstance.exportChart(
          {
            type: "image/jpeg",
            filename: this.chartName,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 2:
        this.chartInstance.exportChart(
          {
            type: "application/pdf",
            filename: this.chartName,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 3:
        this.chartInstance.exportChart(
          {
            type: "image/svg+xml",
            filename: this.chartName,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 4:
        this.chartInstance.print();
        break;
      default:
        break;
    }
  }

  updateChartTickers(tickerData) {
    this.isVisibleEditTickerModal = false;
    this.tickerModalDataReady = false;
    this.leftModalDataReady = false;
    const tickers = tickerData.map((el) => el.ticker);
    const data = {
      chart_name: this.chartName,
      chart_id: this.chartId,
      tickers,
    };
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
    } else {
      this.dataService.updateCharts(data).subscribe((res) => {
        if (res["status"] === "success") {
          this.appService.logUserAction(
            {},
            "",
            "",
            "CHARTS_EDIT_TICKERS",
            { tickers: tickers, chart_id: this.chartId },
            "",
            "CHARTS_PAGE",
          );
        }
      });
    }
    this.chartsMetaRaw["ticker_info"] = tickerData;
    this.chartsMeta.filters.tickers = tickerData.map((tInfo) => {
      return {
        name: tInfo.name,
        ticker: tInfo.ticker,
      };
    });
    this.rowTickers = tickerData.map((data) => {
      return data.ticker;
    });
    this.addRowTableData = tickerData;
    //this.mpt = this.mpt; //need to get mpt from BE in update response
    const postObj = {
      tickers: this.rowTickers,
      show_suggested_lines: true,
    };
    this.dataService.getStdLineItems(postObj).subscribe((res) => {
      this.leftModalDataReady = true;
      this.stdLineItems = [...res.data];
      const _suggestedLines: Array<any> = res.data.filter(
        (d) => d.tab_full_name === "Suggested Line Items",
      );
      this.suggestedLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];
      if (this.suggestedLines.length > 0) {
        this.suggestedLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ].concat(this.suggestedLines);
      } else {
        this.suggestedLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ].concat(this.suggestedLines);
      }
    });
    this.dataService.getCompanyPeers(this.rowTickers, null).subscribe((res) => {
      if (res.status === "success") {
        this.peerCompanies = this.appService
          .cloneArray(res.peer_info)
          .map((item) => ({ ...item, full_name: item.name }));
        if (this.peerCompanies.length) {
          const peerComps = this.peerCompanies.map((pc) => {
            const company = {
              name: pc.name,
              ticker: pc.ticker,
              sli_comps_id: 0,
              mpt: pc.mpt,
              isSelected: false,
            };
            return company;
          });
          if (this.watchlistData[0].watchername === "Suggested Peers") {
            this.watchlistData[0].company_info = peerComps;
            this.watchlistData = [...this.watchlistData];
          } else {
            this.watchlistData = this.watchlistData.slice(0, -1);
            this.watchlistData.unshift({
              watchername: "Suggested Peers",
              company_info: peerComps,
            });
          }
        } else {
          if (this.watchlistData[0].watchername === "Suggested Peers") {
            this.watchlistData = this.watchlistData.slice(1);
            this.watchlistData.push({
              watchername: "Suggested Peers",
              company_info: [],
            });
          }
        }
      }
      this.tickerModalDataReady = true;
    });
    this.selectedFilters = {
      ...this.selectedFilters,
      tickers: tickers,
      selectedTickersInfo: this.chartsMeta.filters.tickers,
    };
    this.getPeriodsWithAvailableData(this.rowTickers);
  }

  onSearchTickerSelection(tickerData) {
    const { value, tickers } = tickerData;
    if (this.rowTickers.includes(value.ticker)) {
      this.snackbarMessage = "This ticker is already present.";
      this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
        panelClass: "info",
        duration: 5000,
        verticalPosition: "top",
      });
    } else {
      if (tickers.length <= 10) {
        this.updateSearchedTicker(tickerData);
      }
    }
  }

  updateSelectedTickerData(tickers, selectedTicker) {
    const allSelectedTickers = this.addRowTableData.concat(selectedTicker);
    this.chartsMeta.filters.tickers = allSelectedTickers.map((tInfo) => {
      return {
        name: tInfo.name,
        ticker: tInfo.ticker,
      };
    });
    this.rowTickers = tickers;
    this.addRowTableData = allSelectedTickers;
    this.chartsMetaRaw["ticker_info"] = allSelectedTickers;
    this.selectedFilters = {
      ...this.selectedFilters,
      tickers: tickers,
      selectedTickersInfo: this.chartsMeta.filters.tickers,
    };

    this.snackbarMessage = `${selectedTicker.name} has been added to the chart.`;
    this.snackBarRef = this.snackBar.openFromTemplate(this.successTemplate, {
      panelClass: "success",
      duration: 5000,
      verticalPosition: "top",
    });

    this.appService.logUserAction(
      {},
      "",
      "",
      "CHARTS_EDIT_TICKERS",
      { tickers: tickers, chart_id: this.chartId },
      "",
      "CHARTS_PAGE",
    );
  }

  updateSearchedTicker(tickerData) {
    if (tickerData.value.mpt !== this.mpt) {
      this.snackbarMessage = `Error: We currently cannot create a chart table with tickers from BOTH ${
        this.mptList[this.mpt]
      } and ${this.mptList[tickerData.value.mpt]} sectors.`;
      this.snackBarRef = this.snackBar.openFromTemplate(this.failureTemplate, {
        panelClass: "failure",
        duration: 5000,
        verticalPosition: "top",
      });
    } else {
      const company = {};
      company["name"] = tickerData.value.full_name;
      company["sli_comps_id"] = 0;
      company["ticker"] = tickerData.value.ticker;
      company["mpt"] = tickerData.value.mpt;
      company["isSelected"] = true;

      this.isVisibleEditTickerModal = false;
      this.tickerModalDataReady = false;
      this.leftModalDataReady = false;
      const tickers = tickerData.tickers;
      const data = {
        chart_name: this.chartName,
        chart_id: this.chartId,
        tickers,
      };
      if (this.chartId === "suggested" || this.chartId === "current") {
        this.hasUnsavedData = true;
        this.updateSelectedTickerData(tickers, company);
      } else {
        this.dataService.updateCharts(data).subscribe((res) => {
          if (res["status"] === "success") {
            this.updateSelectedTickerData(tickers, company);
          }
        });
      }
      // this.chartsMetaRaw["ticker_info"] = tickerData;
      // this.chartsMeta.filters.tickers = tickerData.map((tInfo) => {
      //   return {
      //     name: tInfo.name,
      //     ticker: tInfo.ticker
      //   };
      // });
      this.rowTickers = tickerData.tickers;
      // this.addRowTableData = tickerData;
      //this.mpt = this.mpt; //need to get mpt from BE in update response
      const postObj = {
        tickers: this.rowTickers,
        show_suggested_lines: true,
      };
      this.dataService.getStdLineItems(postObj).subscribe((res) => {
        this.leftModalDataReady = true;
        this.stdLineItems = [...res.data];
        const _suggestedLines: Array<any> = res.data.filter(
          (d) => d.tab_full_name === "Suggested Line Items",
        );
        this.suggestedLines = _suggestedLines.length
          ? _suggestedLines[0].tab_sli_data.map((l) => {
              return {
                disabled: false,
                label: l.name,
                isLeaf: true,
                level: 2,
                header: false,
                sliid: l.sli_id,
                line_count: l.line_count,
                id: l.uniquesliid,
              };
            })
          : [];
        if (this.suggestedLines.length > 0) {
          this.suggestedLines = [
            {
              suggestion_header: "Suggestions: ",
              isLeaf: true,
              disabled: true,
            } as any,
          ].concat(this.suggestedLines);
        } else {
          this.suggestedLines = [
            {
              suggestion_header: "No suggestion found ",
              isLeaf: true,
              disabled: true,
            } as any,
          ].concat(this.suggestedLines);
        }
      });
      this.dataService
        .getCompanyPeers(this.rowTickers, null)
        .subscribe((res) => {
          if (res.status === "success") {
            this.peerCompanies = this.appService
              .cloneArray(res.peer_info)
              .map((item) => ({ ...item, full_name: item.name }));
            if (this.peerCompanies.length) {
              const peerComps = this.peerCompanies.map((pc) => {
                const company = {
                  name: pc.name,
                  ticker: pc.ticker,
                  sli_comps_id: 0,
                  mpt: pc.mpt,
                  isSelected: false,
                };
                return company;
              });
              if (this.watchlistData[0].watchername === "Suggested Peers") {
                this.watchlistData[0].company_info = peerComps;
                this.watchlistData = [...this.watchlistData];
              } else {
                this.watchlistData = this.watchlistData.slice(0, -1);
                this.watchlistData.unshift({
                  watchername: "Suggested Peers",
                  company_info: peerComps,
                });
              }
            } else {
              if (this.watchlistData[0].watchername === "Suggested Peers") {
                this.watchlistData = this.watchlistData.slice(1);
                this.watchlistData.push({
                  watchername: "Suggested Peers",
                  company_info: [],
                });
              }
            }
          }
          this.tickerModalDataReady = true;
        });

      this.getPeriodsWithAvailableData(this.rowTickers);
    }
  }

  getLineInfoAndUpdateStore(lineids: Array<number>, LiData: any) {
    const selectedPeriodList = getSelectedPeriods(
      this.filterData.yearType,
      true,
    );
    const otherPeriodList = getOtherPeriods(this.filterData.yearType);
    const periodType = getPeriodTypeDataId(this.filterData.yearType);
    const periodMetaUrl = this.createPeriodMetaUrl(
      selectedPeriodList,
      otherPeriodList,
      this.filterData.yearType.is_annual_selected,
      periodType,
    );
    this.dataService
      .getChartsMeta(
        `line_ids=${lineids.join("&line_ids=")}&currency=${
          this.chartsMeta.filters.currency
        }&ticker=${this.rowTickers.join(
          "&ticker=",
        )}${periodMetaUrl}&chart_type_id=${this.chartTypeId}`,
      )
      .subscribe((res) => {
        if (res["status"] === "success") {
          this.chartsMetaRaw["line_info"] = res.line_info;
          this.chartsMeta.filters.lines = res.line_info.map((lInfo) => {
            return {
              name: lInfo.name,
              uniqueSliId: lInfo.uniquesliid,
              unit: lInfo.unit,
              magnitude: lInfo.magnitude,
              currSymbol: lInfo.curr_symbol,
              isValuationRatio: lInfo.is_valuation_ratio,
            };
          });
          if (LiData === null) {
            this.addColTableData = res.line_info;
            this.selectedLiId = res.line_info.map((item) => item.uniquesliid);
          } else {
            this.addColTableData = LiData;
            this.selectedLiId = LiData.map((item) => item.uniquesliid);
          }
          const lineInfoDict = {};
          this.lines = this.chartsMeta.filters.lines.map((data) => {
            lineInfoDict[data.uniqueSliId] = data;
            return data.uniqueSliId;
          });
          this.selectedFilters = {
            ...this.selectedFilters,
            lines: lineids,
            lineInfo: lineInfoDict,
            currency: this.chartsMeta.filters.currency,
          };
          this.leftModalDataReady = true;
        }
      });
  }

  updateChartLI(LiData) {
    this.isVisibleEditLiModal = false;
    this.leftModalDataReady = false;
    const lineids = LiData.map((el) => el.uniquesliid);
    const data = {
      chart_id: this.chartId,
      line_ids: lineids,
    };
    if (this.chartId === "suggested" || this.chartId === "current") {
      this.hasUnsavedData = true;
      this.getLineInfoAndUpdateStore(lineids, LiData);
    } else {
      this.dataService.updateCharts(data).subscribe((res) => {
        if (res["status"] === "success") {
          this.getLineInfoAndUpdateStore(lineids, LiData);
        }
      });
    }
    this.appService.logUserAction(
      {},
      "",
      "",
      "CHARTS_EDIT_LINEITEMS",
      { line_ids: lineids, chart_id: this.chartId },
      "",
      "CHARTS_PAGE",
    );
  }

  saveToCustomChartAction() {
    this.hasUnsavedData = false;
    this.saveToCustomChart();
  }

  saveToCustomChart(name?, donotNavigate?) {
    let metaData = {};
    const chartFilters: ChartFilters = this.chartsMeta.filters;
    const periodSettings = convertPeriodMetaToUserSettings(
      this.filterData.yearType,
    );
    switch (this.chartTypeId) {
      case 3:
        metaData = {
          currency: chartFilters.currency,
          revision: chartFilters.revisionPeriod,
          scale_type: chartFilters.scaleType,
          period: periodSettings,
        };
        break;
      case 2:
        metaData = {
          currency: chartFilters.currency,
          // period: {
          //   from: chartFilters.periods["from"],
          //   to: chartFilters.periods["to"]
          // },
          period: periodSettings,
          scale_type: chartFilters.scaleType,
          viewBy: chartFilters.dataView,
        };
        break;
      default:
        metaData = {};
    }
    const tickers = chartFilters.tickers.map((el) => el.ticker);
    const lineids = chartFilters.lines.map((el: LineInfo) => el.uniqueSliId);
    const reqObj = {
      chart_name: name ? name : this.chartName,
      chart_type_id: this.chartTypeId,
      line_ids: lineids,
      tickers: tickers,
      chart_meta_data: metaData,
    };
    this.dataService.saveNewChart(reqObj).subscribe((res) => {
      if (res["status"] === "success") {
        if (donotNavigate === true) {
          this.store.dispatch(
            new UpdateChartsData({
              chartId: res.chart_id,
              label: reqObj["chart_name"],
              operation: "add",
              chartTypeId: reqObj["chart_type_id"],
            }),
          );
        } else {
          this.chartId = res.chart_id;
          this.router.navigate([`/charts/${this.chartId}`]).then(() => {
            this.store.dispatch(
              new UpdateChartsData({
                chartId: this.chartId,
                label: reqObj["chart_name"],
                operation: "add",
                chartTypeId: reqObj["chart_type_id"],
              }),
            );
          });
        }
        this.appService.updateLeftPanelSource.next({
          currentChartData: null,
        });
        this.appService.logUserAction(
          {},
          "",
          "",
          "SAVE_TO_CUSTOM_CHARTS",
          { chart_filter: chartFilters },
          "",
          "CHARTS_PAGE",
        );
      }
      //need to make update LP and chart data calls
    }),
      (err) => {
        console.error(err);
      };
  }

  promptToSave(
    nextState: RouterStateSnapshot,
    suggestedChartDetails: SuggestedChartDetails,
  ) {
    const title = `You're about to leave this page without saving changes.`;

    const message = `Do you want to save to Custom Chart before proceeding?`;

    const primaryAction = () => {
      this.hasUnsavedData = false;
      this.promptModal.close(true);
      this.promptModal = null;
      this.saveToCustomChart(null, true);
      if (suggestedChartDetails === null) {
        if (nextState.url.startsWith("/charts/current")) {
          this.router.navigate(["/charts/current"], {
            queryParams: nextState.root.queryParams,
          });
        } else {
          this.router.navigate([nextState.url], {
            state: {
              fromLP: true,
            },
          });
        }
      } else {
        this.getSuggestedChartsMeta(suggestedChartDetails);
      }
    };

    const notSaveAction = () => {
      this.hasUnsavedData = false;
      this.promptModal.close(true);
      this.promptModal = null;
      if (suggestedChartDetails === null) {
        if (nextState.url.startsWith("/charts/current")) {
          this.router.navigate(["/charts/current"], {
            queryParams: nextState.root.queryParams,
          });
        } else {
          this.router.navigate([nextState.url], {
            state: {
              fromLP: true,
            },
          });
        }
      } else {
        this.getSuggestedChartsMeta(suggestedChartDetails);
      }
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ee8733",
      icon: faExclamationTriangle as IconDefinition,
      actionPrimaryText: "Save",
      actionSecondaryText: "Cancel",
      actionthirdText: "Don't Save",
      onThirdClick: notSaveAction,
      onPrimaryClick: primaryAction,
      onSecondaryClick: () => {
        this.promptModal.close(false);
        this.promptModal = null;
        if (suggestedChartDetails === null) {
          this.store.dispatch(new UpdateChartsData(null));
        } else {
          this.appService.updateLeftPanelSource.next({
            suggestedChartIndex: this.suggestedChartIndex,
          });
        }
      },
    };

    this.promptModal = this.commonModalService.create(modalOptions);
  }

  ngOnDestroy() {
    this.createChartsSubscriber.unsubscribe();
    this.suggestedChartDetailsSubscriber.unsubscribe();
    this.chartInstanceSubscriber.unsubscribe();
    if (this.chartsMetaSubscriber) {
      this.chartsMetaSubscriber.unsubscribe();
    }
    if (this.getUSerChartIdSubscription) {
      this.getUSerChartIdSubscription.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
  }

  showEditTickersModal() {
    this.isVisibleEditTickerModal = true;
  }

  onCloseEditTickersModal = (ev) => {
    if (ev === true) this.isVisibleEditTickerModal = false;
  };

  showEditLiModal() {
    this.isVisibleEditLiModal = true;
  }

  onCloseEditLiModal = (ev) => {
    if (ev === true) this.isVisibleEditLiModal = false;
  };

  onSearchedLi(e) {
    this.leftModalDataReady = false;
    // const company = {};
    // company["ticker"] = tickerInfo.ticker;
    // company["name"] = tickerInfo.full_name;
    // company["isSelected"] = true;
    // const tickerExist = this.modalData.filter((data) => {
    //   return data.ticker === tickerInfo.ticker;
    // });
    // if (tickerExist.length === 0) {
    //   this.modalData.push(company);
    //   this.onLiUpdate.emit(this.modalData);
    // }
    // let a = {};
    // if(this.addColTableData.length === 2){
    //    a = this.addColTableData.shift();
    // }
    this.addColTableData = [];
    const lineids = this.addColTableData.map((el) => el.uniquesliid);
    if (!lineids.includes(e.id)) {
      const liData = { ...e };
      liData.name = e.label;
      let lineItem = {};
      lineItem = {
        name: liData.label,
        period:
          this.selectedFilters &&
          this.selectedFilters.periods &&
          this.selectedFilters.otherPeriods
            ? this.selectedFilters.periods.concat(
                this.selectedFilters.otherPeriods,
              )
            : undefined,
        sli_comps_id: 0,
        sli_id: e.sliid,
        uniquesliid: e.id,
        source: "vaactuals.consensus",
        isSelected: true,
        line_count: e.line_count ? `${e.line_count.toString()}` : null,
      };
      // const LiData = [...this.addColTableData, lineItem];
      const LiData = this.addColTableData.concat(lineItem);
      this.addColTableData = LiData;

      lineids.push(e.id);
      const data = {
        chart_id: this.chartId,
        line_ids: lineids,
      };
      this.snackbarMessage = `The chart has been updated to show  ${liData.label}`;
      if (this.chartId === "suggested" || this.chartId === "current") {
        this.hasUnsavedData = true;
        this.getLineInfoAndUpdateStore(lineids, LiData);
        this.snackBarRef = this.snackBar.openFromTemplate(
          this.successTemplate,
          {
            panelClass: "success",
            duration: 5000,
            verticalPosition: "top",
          },
        );
      } else {
        this.dataService.updateCharts(data).subscribe((res) => {
          if (res["status"] === "success") {
            this.getLineInfoAndUpdateStore(lineids, LiData);
            this.snackBarRef = this.snackBar.openFromTemplate(
              this.successTemplate,
              {
                panelClass: "success",
                duration: 5000,
                verticalPosition: "top",
              },
            );
          }
        });
      }
    } else {
      this.leftModalDataReady = true;
      this.snackbarMessage = "This line item is already present.";
      this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
        panelClass: "info",
        duration: 5000,
        verticalPosition: "top",
      });
    }
  }

  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }

  onChartInstance(chartInstance: Highcharts.Chart) {
    if (chartInstance) {
      this.chartInstance = chartInstance;
    }
  }
}
